module.exports = __webpack_public_path__ + "public/images/Illustration_Coding_200x174.7706c88c15e0a19bd18da57bf52a61df.png";